import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import MoreVert from "@material-ui/icons/MoreVert";
import ViewList from "@material-ui/icons/ViewList";
import Reply from "@material-ui/icons/Reply";
import HeaderLinksCustomized from "./HeaderLinksCustomized";

// core components
import ManageUsersHeader from "./ManageUsersHeader";
import AddUsersHeader from "./AddUsersHeader";
// import TransactionListingHeader from "./TransactionListingHeader";
// import RatingsHeader from "./RatingsHeader";
import Button from "components/CustomButtons/Button.jsx";

import { hist } from "../../index";

import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import ManageCategoryHeader from "./ManageCategoryHeader";
import AddCategoryHeader from "./AddCategoryHeader";
import ManageSpeakerHeader from "./ManageSpeakerHeader";
import AddSpeakerHeader from "./AddSpeakerHeader";
import ManageStaffHeader from "./ManageStaffHeader";
import AddStaffHeader from "./AddStaffHeader";
import ManageEventHeader from "./ManageEventHeader";
import AddEventHeader from "./AddEventHeader";
import AddWebinarHeader from "./AddWebinar";

import ManageWebinarHeader from "./ManageWebinarHeader";

import AddVipHeader from "./addvip";
import VipWebinarHeader from "./addVipHeader";
import ManageFAQHeader from "./ManageFAQHeader";
import ManageNewsAndAnnouncementHeader from "./ManageNewsAndAnnouncementHeader";

import AddCoupon from "./AddCouponHeader";
import ManageCoupon from "./ManageCouponHeader";
import ManageAdminHeader from "./ManageAdminHeader";
import AddAdminHeader from "./AddAdminHeader";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showProductBack: false,
      showImageBack: false,
      showUserBack: false,
      showNotificationBack: false,
      showContentBack: false,
      msg: "",
      currentCatFaqId: null,
    };
  }

  makeBrand = () => {
    var name;
    this.props.routes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      }
      if (prop.path === this.props.location.pathname) {
        name = prop.name;
      }
      return null;
    });
    return name;
  };

  componentWillReceiveProps = () => {};

  backToRoute = (route, data) => {
    hist.push(`/${route}`, data);
  };

  render() {
    const { classes, color, rtlActive } = this.props;
    const appBarClasses = cx({
      [" " + classes[color]]: color,
    });
    const sidebarMinimize =
      classes.sidebarMinimize +
      " " +
      cx({
        [classes.sidebarMinimizeRTL]: rtlActive,
      });
    return (
      <div>
        <AppBar className={classes.appBar + appBarClasses}>
          <Toolbar className={classes.container}>
            <Hidden smDown implementation="css">
              <div className={sidebarMinimize}>
                {this.props.miniActive ? (
                  <Button
                    justIcon
                    round
                    color="white"
                    onClick={this.props.sidebarMinimize}
                  >
                    <ViewList className={classes.sidebarMiniIcon} />
                  </Button>
                ) : (
                  <Button
                    justIcon
                    round
                    color="white"
                    onClick={this.props.sidebarMinimize}
                  >
                    <MoreVert className={classes.sidebarMiniIcon} />
                  </Button>
                )}
              </div>
            </Hidden>
            <div className={classes.flex}>
              <Button href="#" className={classes.title} color="transparent">
                {this.makeBrand() || ""}
              </Button>
            </div>
            <Hidden smDown implementation="css">
              {/* 

              {this.props.location.pathname === "/admin/viewTransactions" && (
                <TransactionListingHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/rating-list" && (
                <RatingsHeader rtlActive={rtlActive} />
              )} */}
              {this.props.location.pathname ===
                "/admin/managecoupon/addcoupon" && (
                <AddCoupon rtlActive={rtlActive} />
              )}
              {this.props.location.pathname ===
                "/admin/managecoupon/editcoupon" && (
                <AddCoupon rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managecoupon/couponlist" && (
                <ManageCoupon rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/manageusers" && (
                <ManageUsersHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/addusers" && (
                <AddUsersHeader rtlActive={rtlActive} />
              )}
              {this.props.location.pathname ===
                "/admin/manageevents/eventlist" && (
                <ManageEventHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/manageevents/eventdetail" && (
                <AddEventHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/manageevents/addevent" && (
                <AddEventHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/manageevents/editevent" && (
                <AddEventHeader rtlActive={rtlActive} />
              )}
              {this.props.location.pathname ===
                "/admin/managewebinar/addwebinar" && (
                <AddWebinarHeader rtlActive={rtlActive} />
              )}
              {this.props.location.pathname ===
                "/admin/vip/viplist/vipbookingdetails" && (
                <AddWebinarHeader rtlActive={rtlActive} />
              )}
              {this.props.location.pathname ===
                "/admin/managewebinar/editwebinar" && (
                <AddWebinarHeader rtlActive={rtlActive} />
              )}
              {this.props.location.pathname ===
                "/admin/managewebinar/webinardetail" && (
                <AddWebinarHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/vip/addvip" && (
                <AddVipHeader rtlActive={rtlActive} />
              )}
              {/* {this.props.location.pathname === "/admin/vip/editvip" && (
                <AddVipHeader rtlActive={rtlActive} />
              )} */}
              {this.props.location.pathname === "/admin/vip/vipdetail" && (
                <AddVipHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/vip/viplist" && (
                <VipWebinarHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managewebinar/webinarlist" && (
                <ManageWebinarHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/newsandannouncements/newsandannouncementlist" && (
                <ManageNewsAndAnnouncementHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/newsandannouncements/addnewsandannouncement" && (
                <AddStaffHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/newsandannouncements/editnewsandannouncement" && (
                <AddStaffHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managestaff/stafflist" && (
                <ManageStaffHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managestaff/addstaff" && (
                <AddStaffHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managestaff/viewstaff" && (
                <AddStaffHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managestaff/editstaff" && (
                <AddStaffHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managespeaker/speakerlist" && (
                <ManageSpeakerHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managespeaker/addspeaker" && (
                <AddSpeakerHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managespeaker/viewspeaker" && (
                <AddSpeakerHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managespeaker/editspeaker" && (
                <AddSpeakerHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managecategory/categorylist" && (
                <ManageCategoryHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managecategory/addcategory" && (
                <AddCategoryHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname ===
                "/admin/managecategory/editcategory" && (
                <AddCategoryHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/faq" && (
                <ManageFAQHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/add-faq" && (
                <AddCategoryHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/view-faq" && (
                <AddCategoryHeader rtlActive={rtlActive} />
              )}

              {this.props.location.pathname === "/admin/edit-faq" && (
                <AddCategoryHeader rtlActive={rtlActive} />
              )}
              {this.props.location.pathname === "/admin/manage-admin/list" && (
                <ManageAdminHeader rtlActive={rtlActive} />
              )}
              {this.props.location.pathname === "/admin/manage-admin/add" && (
                <AddAdminHeader rtlActive={rtlActive} />
              )}
            </Hidden>
            <HeaderLinksCustomized rtlActive={rtlActive} />
            {this.props.location.pathname === "/dashboard/viewproducts" && (
              <Button
                color="info"
                round
                className={classes.marginRight}
                onClick={() => this.backToRoute("dashboard/products")}
              >
                <Reply className={classes.icons} /> Back
              </Button>
            )}

            {this.props.location.pathname &&
              this.props.location.pathname.includes(
                "/admin/managewebinar/registrationDetails"
              ) && (
                <Button
                  color="info"
                  id="fadeshow1"
                  round
                  className={`${classes.marginRight} btn`}
                  onClick={() => hist.goBack()}
                >
                  <Reply className={classes.icons} /> Back
                </Button>
              )}

            {this.props.location.pathname &&
              this.props.location.pathname.includes(
                "/admin/manageevent/eventregistrationDetails"
              ) && (
                <Button
                  color="info"
                  id="fadeshow1"
                  round
                  className={`${classes.marginRight} btn`}
                  onClick={() => hist.goBack()}
                >
                  <Reply className={classes.icons} /> Back
                </Button>
              )}

            <Hidden mdUp implementation="css">
              <Button
                className={classes.appResponsive}
                color="transparent"
                justIcon
                aria-label="open drawer"
                onClick={this.props.handleDrawerToggle}
              >
                <Menu />
              </Button>
            </Hidden>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
};

export default withStyles(headerStyle)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx